export default __webpack_public_path__ + "static/media/chocolate.d91f1070.webp";